/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useState } from "react";
import pru_webQR from "../../img/qr/FundzBazar_WebQR.png"
import pru_mobileQR from "../../img/qr/FundzBazar_MobileQR.png"
import pru_logo from "../../img/logos/prudent_logo.png"
import sbi_logo from "../../img/logos/SBI_mf.jpg"
import kotak_logo from "../../img/logos/kotak_mf.png"
import aditya_logo from "../../img/logos/aditya_birla_mf.jpg"
import nippon_logo from "../../img/logos/nippon_mf.png"
import fundbazar_logo from "../../img/logos/fundBazar.png"

const amcPartners = [

  {
    id: 1,
    name: "ICICI Prudential",
    platform: "FundBazar",
    logo: pru_logo,

    description:
      "Access ICICI Prudential Mutual Funds through the FundBazar investment ecosystem.",

    webLink: "https://fundzbazar.com/Link/8iZ0uvzw-q0",

    mobileLink: "https://fundzbazar.com/Link/h2_ibDRiVoQ",

    qr: pru_webQR,

    features: [
      "SIP & Lumpsum",
      "Online KYC",
      "Portfolio Tracking",
    ],
  },

  {
    id: 2,
    name: "SBI Mutual Fund",
    platform: "SBI MF Platform",
    logo: sbi_logo,

    description:
      "Invest in SBI Mutual Fund schemes with secure online onboarding.",

    webLink: "#",

    mobileLink: "#",

    qr: "/qr/sbi.png",

    features: [
      "Direct AMC Access",
      "Large Fund Selection",
      "Trusted AMC",
    ],
  },

  {
    id: 3,
    name: "Kotak Mutual Fund",
    platform: "Kotak Connect Plus",
    logo: kotak_logo,

    description:
      "Financial Products Distribution made Super Easy.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },

      {
    id: 4,
    name: "Nippon Mutual Fund",
    platform: "Nippon MF",
    logo: nippon_logo,

    description:
      "Wealth Sets you Free.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },


      {
    id: 5,
    name: "Aditya Birla Mutual Fund",
    platform: "ABSLMF Investor App",
    logo: aditya_logo,

    description:
      "Invest Aaj For Kal.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },



];


const platforms = [

  {
    id: "icici",

    name: "ICICI Prudential",

    logo: pru_logo,

    description:
      "Access ICICI Prudential Mutual Funds through the FundBazar investment ecosystem.",

    platformName: "FundBazar",
    webLink: "https://fundzbazar.com/Link/8iZ0uvzw-q0",

    mobileLink: "https://fundzbazar.com/Link/h2_ibDRiVoQ",


    qr: pru_webQR,

    color: "orange",

    theme: {
      active:
        "bg-orange-600 text-white border-orange-600",

      inactive:
        "bg-white border-gray-200 hover:border-orange-300",

      text:
        "text-orange-700",

      soft:
        "bg-orange-50",
    },

    features: [
      "SIP Investing",
      "Lumpsum Investments",
      "Goal Planning",
      "Direct ARN Tracking"
    ]
  },

  {
    id: "sbi",

    name: "SBI Mutual Fund",

    logo: sbi_logo,

    description:
      "Access SBI Mutual Fund investment platform integrated with Orion Analytics.",

    platformName: "SBI Smart Invest",

    webLink:
      "#",

    mobileLink:
      "#",

    qr: "#",

    color: "blue",

    theme: {
      active:
        "bg-blue-600 text-white border-blue-600",

      inactive:
        "bg-white border-gray-200 hover:border-blue-300",

      text:
        "text-blue-700",

      soft:
        "bg-blue-50",
    },

    features: [
      "SIP",
      "Tax Saver Funds",
      "Retirement Planning"
    ]
  },

      {
    id: "kotak",
    name: "Kotak Mutual Fund",
    platformName: "Kotak Connect Plus",
    logo: kotak_logo,

    description:
      "Financial Products Distribution made Super Easy.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",
   color: "blue",

    theme: {
      active:
        "bg-blue-900 text-blue border-blue-900",

      inactive:
        "bg-white border-gray-200 hover:border-blue-300",

      text:
        "text-blue-900",

      soft:
        "bg-blue-50",
    },

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },

      {
    id: "nipon",
    name: "Nippon Mutual Fund",
    platformName: "Nippon MF",
    logo: nippon_logo,

    description:
      "Wealth Sets you Free.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",
   color: "red",

    theme: {
      active:
        "bg-red-600 text-white border-red-600",

      inactive:
        "bg-white border-gray-200 hover:border-red-300",

      text:
        "text-red-700",

      soft:
        "bg-red-50",
    },

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },


      {
    id: "adityamf",
    name: "Aditya Birla Mutual Fund",
    platformName: "ABSLMF Investor App",
    logo: aditya_logo,

    description:
      "Invest Aaj For Kal.",

    webLink: "#",
    mobileLink: "#",

    color : "yellow",

    theme: {
      active:
        "bg-yellow-700 text-white border-yellow-600",

      inactive:
        "bg-white border-gray-200 hover:border-yellow-300",

      text:
        "text-yellow-700",

      soft:
        "bg-yellow-50",
    },

    qr: "#",

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },

  {
    id: "hdfc",

    name: "HDFC Mutual Fund",

    logo: "/logos/hdfc.png",

    description:
      "Secure HDFC mutual fund investing with ARN linked onboarding.",

    platformName: "HDFC MF Online",

    webLink:
      "https://your-hdfc-link.com",

    mobileLink:
      "https://your-hdfc-mobile.com",

    qr: "/qr/hdfc.png",

    color: "red",

    theme: {
      active:
        "bg-red-600 text-white border-red-600",

      inactive:
        "bg-white border-gray-200 hover:border-red-300",

      text:
        "text-red-700",

      soft:
        "bg-red-50",
    },

    features: [
      "Wealth Creation",
      "Hybrid Funds",
      "Portfolio Tracking"
    ]
  }

];


const MFInvestmentModal = ({
  open,
  onClose,
  fundName = null,
  preselectedPlatform = null
}) => {

  const initialTab =
    preselectedPlatform
      ? preselectedPlatform.toLowerCase()
      : platforms[0].id;

  const [activeTab, setActiveTab] =
    useState(initialTab);

  if (!open) return null;

  const activePlatform =
    platforms.find(
      p => p.id === activeTab
    );

  return (

    <div
      className="
        fixed
        inset-0
        z-[9999]
        bg-black/60
        backdrop-blur-sm
        flex
        items-center
        justify-center
        p-4
      "
    >

      {/* MODAL */}

      <div
        className="
          relative
          w-full
          max-w-6xl
          rounded-[36px]
          overflow-hidden
          shadow-2xl
          bg-white
        "
      >

        {/* HEADER */}

        <div
          className="
            relative
            bg-gradient-to-r
            from-green-900
            to-green-700
            p-8
            text-white
          "
        >

          {/* CLOSE */}
          <div className="flex justify-end">
          <button
            onClick={onClose}
            className="
              text-white
              text-2xl
              font-light
              hover:opacity-70
              transition-all
              bg-transparent
              border-none
              outline-none
              shadow-none
              p-0
              w-auto
              h-auto
              leading-none
            "
          >
            x
          </button>
          </div>
          <div className="max-w-3xl">

            <div
              className="
                text-sm
                uppercase
                tracking-[0.3em]
                opacity-80
                mb-3
              "
            >
              Orion Analytics
            </div>

            <div
              className="
                text-4xl
                font-black
                mb-4
              "
            >
              Invest Through Trusted Partners
            </div>

            {fundName && (

              <div
                className="
                  bg-white/10
                  border
                  border-white/20
                  rounded-2xl
                  p-4
                  inline-block
                  backdrop-blur-sm
                "
              >

                <div className="text-sm opacity-80">
                  Selected Fund
                </div>

                <div className="font-bold text-lg">
                  {fundName}
                </div>

              </div>

            )}

          </div>

        </div>

        {/* BODY */}

        <div
          className="
            grid
            grid-cols-12
            min-h-[550px]
          "
        >

          {/* LEFT TABS */}

          <div
            className="
              col-span-3
              border-r
              border-gray-100
              bg-gray-50
              p-6
            "
          >

            <div
              className="
                text-sm
                uppercase
                tracking-widest
                text-gray-400
                mb-5
              "
            >
              Investment Platforms
            </div>
            <div
              className="
                lg:col-span-4
                max-h-[65vh]
                overflow-y-auto
                pr-2
                custom-scrollbar
              "
            >
            <div className="space-y-3">

            {platforms.map((platform) => (

              <button
                key={platform.id}
                onClick={() =>
                  setActiveTab(platform.id)
                }
                className={`
                  w-full
                  text-left
                  rounded-2xl
                  p-4
                  transition-all
                  border
                  ${
                    activeTab === platform.id
                      ? platform.theme.active
                      : platform.theme.inactive
                  }
                `}
              >

                <div
                  className="
                    flex
                    items-center
                    gap-4
                  "
                >

                  {/* LOGO WRAPPER */}

                  <div
                    className={`
                      w-14
                      h-14
                      rounded-2xl
                      flex
                      items-center
                      justify-center
                      border
                      ${
                        activeTab === platform.id
                          ? "bg-white/20 border-white/20"
                          : platform.theme.soft
                      }
                    `}
                  >

                    <img
                      src={platform.logo}
                      alt={platform.name}
                      className="
                        w-10
                        h-10
                        object-contain
                      "
                    />

                  </div>


                  {/* TEXT */}

                  <div>

                    <div
                      className={`
                        text-lg
                        font-bold
                        ${
                          activeTab === platform.id
                            ? "text-white"
                            : platform.theme.text
                        }
                      `}
                    >
                      {platform.name}
                    </div>

                    <div
                      className={`
                        text-sm
                        mt-1
                        ${
                          activeTab === platform.id
                            ? "text-white/80"
                            : "text-gray-500"
                        }
                      `}
                    >
                      {platform.platformName}
                    </div>

                  </div>

                </div>

              </button>

            ))}
            </div>
            </div>
          </div>

          {/* RIGHT PANEL */}

          <div
            className="
              col-span-9
              p-10
            "
          >

            <div
              className="
                flex
                items-start
                justify-between
                gap-8
                mb-10
              "
            >

              <div className="max-w-2xl">

                <div
                  className="
                    flex
                    items-center
                    gap-4
                    mb-5
                  "
                >

                  <img
                    src={activePlatform.logo}
                    alt=""
                    className="
                      w-20
                      h-20
                      object-contain
                      rounded-2xl
                      border
                      p-2
                    "
                  />

                  <div>

                    <div
                      className="
                        text-3xl
                        font-black
                      "
                    >
                      {activePlatform.name}
                    </div>

                    <div className="text-gray-500">
                      Platform:
                      {" "}
                      {activePlatform.platformName}
                    </div>

                  </div>

                </div>

                <div
                  className="
                    text-lg
                    text-gray-600
                    leading-8
                    mb-8
                  "
                >
                  {activePlatform.description}
                </div>

                <div className="grid grid-cols-2 gap-4">

                  {activePlatform.features.map(
                    (feature, idx) => (

                    <div
                      key={idx}
                      className="
                        bg-green-50
                        border
                        border-green-100
                        rounded-xl
                        px-4
                        py-3
                        font-medium
                        text-green-900
                      "
                    >
                      ✓ {feature}
                    </div>

                  ))}

                </div>

              </div>

              {/* QR */}

              <div
                className="
                  bg-gray-50
                  rounded-3xl
                  p-6
                  text-center
                  border
                "
              >

                <div
                  className="
                    text-sm
                    uppercase
                    tracking-widest
                    text-gray-400
                    mb-4
                  "
                >
                  Scan To Invest
                </div>

                <img
                  src={activePlatform.qr}
                  alt=""
                  className="
                    w-52
                    h-52
                    object-contain
                    mx-auto
                  "
                />

              </div>

            </div>

            {/* CTA */}

            <div className="flex gap-5">

              <a
                href={activePlatform.webLink}
                target="_blank"
                rel="noreferrer"
              >

                <button
                  className="
                    bg-green-700
                    hover:bg-green-800
                    text-white
                    px-8
                    py-4
                    rounded-2xl
                    font-bold
                    text-lg
                    transition-all
                  "
                >
                  Open Web Portal
                </button>

              </a>

              <a
                href={activePlatform.mobileLink}
                target="_blank"
                rel="noreferrer"
              >

                <button
                  className="
                    border-2
                    border-green-700
                    text-green-700
                    hover:bg-green-50
                    px-8
                    py-4
                    rounded-2xl
                    font-bold
                    text-lg
                    transition-all
                  "
                >
                  Open Mobile Link
                </button>

              </a>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default MFInvestmentModal;